import { configureStore } from "@reduxjs/toolkit";
import authReducer from './authSlice';
import sidebarToggleReducer from "./sidebarToggleSlice";
import themeReducer from './themeSlice'
import notificationReducer from './notificationSlice';
import privilegeSlice from "./privilegeSlice";
import historicalParamsDataReducer from "./historicalParamsSlice";
import rightSidebarDataReducer from './rightSidebarReturnSlice'
import todayReturnCalculatorReducer from "./todayReturnCalculator";
import totalLiveDataSliceReducer from "./totalLiveDataSlice";
import totalSelectedModelSliceReducer from "./totalSelectedModelSlice";
import notifySliceReducer from "./notifySlice";
import socketSlice from "./socketSlice";
import liveSentimentReducer from "./liveSentimentSlice";
import PreviewTableDataReducer from "./PreviewTableSlice";


const store = configureStore({
    reducer : {
        auth                  : authReducer,
        sidebarToggle         : sidebarToggleReducer,
        theme                 : themeReducer, 
        notification          : notificationReducer,
        privilege             : privilegeSlice,
        historicalParamsData  : historicalParamsDataReducer,
        rightSidebarData      : rightSidebarDataReducer,
        todayReturnCalculator : todayReturnCalculatorReducer,
        allLiveData           : totalLiveDataSliceReducer,
        selectedModelsArr     : totalSelectedModelSliceReducer,
        setNotifyStatusArr    : notifySliceReducer,
        socketInstance        : socketSlice,        
        liveSentimentArr      : liveSentimentReducer,
        previewTableArr       : PreviewTableDataReducer      
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
          serializableCheck: false,
        })
})


export default store;


